<template>
  <div
    class="feed-manager-table__header"
    :class="{ 'feed-manager-table__header--feeds': tableType === FEEDS_TAB }"
  >
    <MdsButton
      v-if="tableType === SCHEDULES_TAB"
      variation="icon-only"
      icon="refresh"
      type="button"
      :disabled="showLoader"
      @click="$emit('refresh')"
    />
    <div class="feed-manager-table__right">
      <MdsSearchField
        :placeholder="translate(placeholder)"
        class="feed-manager-table__search"
        size="small"
        variation="secondary"
        @input="$emit('search', $event)"
      >
      </MdsSearchField>
      <MdsButton
        v-if="tableType === FEEDS_TAB"
        class="feed-manager-table__button"
        size="small"
        variation="primary"
        @click="$emit('createFeed')"
        >{{ translate('main.feeds.header.createFeed') }}</MdsButton
      >
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { MdsButton } from '@mds/button'
import MdsSearchField from '@mds/search-field'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/config/i18n'
import { FEEDS_TAB, SCHEDULES_TAB } from '@/config/tabs'

export default {
  name: 'FeedsTableSearch',
  components: { MdsSearchField, MdsButton },
  mixins: [MwcBaseHelpersMixin],
  props: {
    tableType: {
      type: String,
      default: 'feeds',
    },
  },
  data() {
    return {
      searchText: '',
      defaultConfig,
      FEEDS_TAB,
      SCHEDULES_TAB,
    }
  },
  computed: {
    ...mapState({
      cache: (state) => state.cache.cache,
    }),
    placeholder() {
      return `main.${this.tableType}.header.search`
    },
    showLoader() {
      return this.cache.showLoader
    },
  },
}
</script>

<style lang="scss">
@import '@mds/constants';
@import '@mds/icon/src/icon_mixins';

.feed-manager-table {
  &__header {
    align-items: center;
    justify-content: space-between;
    display: flex;
    border: 1px;
    padding: $mds-space-1-x;
    gap: $mds-space-half-x;
    border-bottom: solid 1px $mds-color-neutral-80;
    &--feeds {
      justify-content: flex-end;
    }
  }

  &__right {
    display: flex;
    gap: $mds-space-half-x;
  }

  &__button {
    padding: $mds-space-half-x $mds-space-1-and-a-half-x $mds-space-half-x
      $mds-space-1-and-a-half-x;
    gap: $mds-space-half-x;
  }

  &__search {
    width: 200px;
    height: 26px;
  }
}
</style>
